import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import { useParams } from 'react-router-dom';
import ArticoloCanvas from '../components/ArticoloCanvas/ArticoloCanvas';

const Articolo = ({pagesLeft,pagesRight,articles}) => {

    // Carica una pagina per volta in corrispondenza dell'articolo cliccato
    const { id } = useParams();

    const articolo = articles.find(a => a.id === id);

    if (!articolo) {
        return <h2>Sto caricando l'articolo...</h2>;
    }

    return (
        <div>
            <Navbar pagesLeft={pagesLeft} pagesRight={pagesRight}></Navbar>
            <ArticoloCanvas title={articolo.title} author={articolo.author} date={articolo.date} text={articolo.text}></ArticoloCanvas>
        </div>
    );
}

export default Articolo